import GerenciamentoParametrosViewModel from "@/shared/view-models/GerenciamentoParametrosViewModel";
import AccountLoged from "@/shared/mixins/AccountLoged";
import RepresentanteController from "@/shared/controllers/representante/representanteController";


const name = 'GerenciamentoParametros'
export default {
  name,

  components: { }, 
  mixins:[AccountLoged],

  props: { },

  mounted () {
    if(!this.hasClaim('Gerenciamento-Parâmetros')) {
      this.$router.push('/sem-acesso')
    }
    this.getSistema()
    this.getNomeGrupo()
    this.getFormaPagamento()
    this.getTipoFrete()
    this.getTipoOnda()
   },

  updated () { },

  data () {
    return { 
      carregandoEnvioRepresentatesCrm:false,
      logs:null,
      habilitar:null,
      numeroSenha: null,
      numeroTentativas: null,
      numeroLimpezaLog: null,
      nomeGrupo: null,
      grupoArray:[],
      formaPagamentoArray:[],
      tipoFreteArray:[],
      tipoOndaArray:[],
      GrupoSelecionado: [],
      GruposSelecionados: [],
      FormaPagamentoSelecionada: null,
      TipoFreteSelecionado: null,
      TipoOndaSelecionado: null,
      novoGerenciamentoParametros : new GerenciamentoParametrosViewModel()
    }
  },

  methods: {
    async enviarRepresentanteCRM(){
      this.carregandoEnvioRepresentatesCrm = true
      const errorToast = { severity: 'error', summary: 'Não foi possível fazer o envio dos represntantes ao crm', life: 3200 }
      
      await RepresentanteController.enviarRepresentanteCRM().requisicao.then((r)=>{
        if(r.data.code == 200){
          this.$toast.add({ severity: 'success', summary: 'Os Representantes foram enviados ao crm com exito', life: 3200 });
        }else{
          this.$toast.add(errorToast);
        }
      }).catch(()=>{
        this.$toast.add(errorToast);
      }).finally(()=> this.carregandoEnvioRepresentatesCrm = false)
    },

    getSistema() {
      this.axios({
        method: "get",
        url:
          process.env.VUE_APP_WEB_API + 
          `SistemaParametros/GetSistemaParametros`,
      })
        .then((response) => {
          /* eslint-disable */
          debugger
          this.novoGerenciamentoParametros.id = response.data.data.id
          this.novoGerenciamentoParametros.numeroSenha = response.data.data.numeroDiasTrocaSenha;
          this.novoGerenciamentoParametros.numeroTentativas = response.data.data.numeroMaximoTentativas;
          this.novoGerenciamentoParametros.numeroDiasLimpezaLog = response.data.data.numeroDiasLimpezaLog;
          this.novoGerenciamentoParametros.tapumeAtivo = response.data.data.tapumeAtivo;
          this.novoGerenciamentoParametros.formaPagamentoId = response.data.data.formaPagamentoId;
          this.novoGerenciamentoParametros.tipoFreteAutomacao = response.data.data.tipoFreteAutomacao;
          this.novoGerenciamentoParametros.descricaoOnda = response.data.data.descricaoOnda;
          this.novoGerenciamentoParametros.parametroAutomacaoId = response.data.data.parametroAutomacaoId;
          
          if (response.data.data.formaPagamentoId != null) {
            this.FormaPagamentoSelecionada = response.data.data.formaPagamentoId;
          }

          if (response.data.data.tipoFreteAutomacao != null) {
            this.TipoFreteSelecionado = response.data.data.tipoFreteAutomacao;
          }

          if (response.data.data.descricaoOnda != null) {
            this.TipoOndaSelecionado = response.data.data.descricaoOnda;
          }

          this.getNomeGrupo()
          this.GruposSelecionados = response.data.data.gruposIsentos;
        })
        .catch(() => {});
    },


    getNomeGrupo() {
      this.axios ({
        method: "get",
        url:
          process.env.VUE_APP_WEB_API + 
          `SistemasParametros/GetNomeGrupo`,
        data: {
          id: this.novoGerenciamentoParametros.nomeGrupo
        }
      })
        .then((response) => {
          this.grupoArray = response.data.data
        })
        .catch(() => {});
    },

    getFormaPagamento() {
      this.axios ({
        method: "get",
        url:
          process.env.VUE_APP_WEB_API + 
          `SistemasParametros/GetFormaPagamento`
      })
        .then((response) => {
          this.formaPagamentoArray = response.data.data
          if (this.novoGerenciamentoParametros.formaPagamentoId) {
            this.FormaPagamentoSelecionada = this.novoGerenciamentoParametros.formaPagamentoId;
          }
        })
        .catch((error) => {
          console.error('Erro ao buscar formas de pagamento:', error);
        });
    },

    getTipoFrete() {
      this.axios ({
        method: "get",
        url:
          process.env.VUE_APP_WEB_API + 
          `SistemasParametros/GetTipoFreteEnum`
      })
        .then((response) => {
          this.tipoFreteArray = response.data
          if (this.novoGerenciamentoParametros.tipoFreteAutomacao) {
            this.TipoFreteSelecionado = this.novoGerenciamentoParametros.tipoFreteAutomacao;
          }
        })
        .catch((error) => {
          console.error('Erro ao buscar tipos de frete:', error);
        });
    },

    getTipoOnda() {
      this.axios ({
        method: "get",
        url:
          process.env.VUE_APP_WEB_API + 
          `SistemasParametros/GetTipoOndaEnum`
      })
        .then((response) => {
          this.tipoOndaArray = response.data
          if (this.novoGerenciamentoParametros.descricaoOnda) {
            this.TipoOndaSelecionado = this.novoGerenciamentoParametros.descricaoOnda;
          }
        })
        .catch((error) => {
          console.error('Erro ao buscar tipos de onda:', error);
        });
    },

  updateParametros() {

      this.axios ({
        method: "put", 
        url:
        process.env.VUE_APP_WEB_API + 
        `SistemasParametros/UpdateParametros`,
        data: {
          NumeroDiasTrocaSenha: this.novoGerenciamentoParametros.numeroSenha,
          NumeroMaximoTentativas: this.novoGerenciamentoParametros.numeroTentativas,
          NumeroDiasLimpezaLog: this.novoGerenciamentoParametros.numeroDiasLimpezaLog,
          TapumeAtivo: this.novoGerenciamentoParametros.tapumeAtivo,
          FormaPagamentoId: this.FormaPagamentoSelecionada,
          TipoFreteAutomacao: this.TipoFreteSelecionado,
          DescricaoOnda: this.TipoOndaSelecionado,
          Id: this.novoGerenciamentoParametros.id,
          gruposIsentos: this.GruposSelecionados,
          ParametroAutomacaoId: this.novoGerenciamentoParametros.parametroAutomacaoId
        }
      })
        .then((response) => {
          response
            this.$toast.add({severity:'success', summary: 'Dados alterados com sucesso', detail:'Seus dados foram alterados', life: 5000});
        })
        .catch(() => {});
    },

   },

  computed: { }, 

};